import { useParams } from "react-router";

import { colors } from "theme/palette";

import DealAvatar from "components/DealAvatar";
import Paper from "components/Paper";
import Stack from "components/Stack";
import Text from "components/Text";

import {
  usePublicDealDetails,
  usePublicMemoDealDetails,
} from "entities/Memo/publicSdk";

const ShareableMemoHeader = () => {
  const params = useParams<{
    token: string;
  }>();
  const token = params.token;

  const { data: deal } = usePublicDealDetails({
    token: token,
  });
  const { data: memo } = usePublicMemoDealDetails({
    token: token,
  });

  return (
    <Paper
      sx={{
        backgroundColor: colors.blue10,
        borderRadius: 0,
      }}
    >
      <Stack direction="row" spacing={2}>
        <DealAvatar
          src={deal?.thumbnail}
          imgix
          imgixWidth={480}
          imgixHeight={240}
          sx={{ width: "240px", height: "120px", objectFit: "cover" }}
        />
        <Stack>
          <Text variant="label" sx={{ color: colors.blue100 }}>
            {memo?.name}
          </Text>
          <Text variant="h1">{deal?.name}</Text>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default ShareableMemoHeader;
